export default __webpack_public_path__ + "static/media/brand.db0a3191.svg";